import { render, staticRenderFns } from "./addNewRequest3.vue?vue&type=template&id=886ef0b6&"
import script from "./addNewRequest3.vue?vue&type=script&lang=js&"
export * from "./addNewRequest3.vue?vue&type=script&lang=js&"
import style0 from "./addNewRequest3.vue?vue&type=style&index=0&id=886ef0b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports